import { Alert, Form, message, Modal, Select, Space, Spin } from "antd";
import { useEffect, useState } from "react";
import Job from "redux/models/job";
import "../../jobCard.scss";
import Candidate from "redux/models/candidate";
import JobSelectOption from "common/components/jobSelect/jobSelect";
import { customJobHandleSearch } from "utilities/generalUtility";

const { Option } = Select;

export default function TransferCandidateModal({
  jobId,
  clientId,
  candidateActivity,
  transferCandidate,
  setTransferCandidate,
  onSuccess,
}) {
  const [form] = Form.useForm();
  const [jobList, setJobList] = useState([]);
  const [isJobsLoading, setIsJobsLoading] = useState(false);
  const [isTransferLoading, setIsTransferLoading] = useState(false);

  const transferCancelHandler = () => {
    form.resetFields();
    setTransferCandidate((prev) => {
      return { ...prev, showModal: false, transferResponse: null };
    });
  };

  const afterModalClose = () => {
    form.resetFields();
    setTransferCandidate((prev) => {
      return { ...prev, showModal: false, transferResponse: null };
    });
  };

  const transferJob = async (jobSourceId, candidateJobEntryId) => {
    try {
      setIsTransferLoading(true);

      const body = {
        transferJobSourceId: jobSourceId,
        candidateJobEntryId,
      };

      await Candidate.transferCandiateJob(body);

      setTransferCandidate((prev) => {
        return { ...prev, showModal: false, transferResponse: null };
      });

      message.success("Candidate transferred successfully");
      onSuccess?.();
    } catch (error) {
      setTransferCandidate((prev) => {
        return { ...prev, transferResponse: error.message };
      });
    } finally {
      setIsTransferLoading(false);
    }
  };

  const getJobsByClientIds = async () => {
    setIsJobsLoading(true);
    try {
      const params = { hasOpenings: true, isCancelled: false };

      const { data } = await Job.v2.getAllByClient(clientId, params, false);

      setJobList(data.filter(({ id }) => +jobId !== id));
    } catch (err) {
      console.error(err);
    } finally {
      setIsJobsLoading(false);
    }
  };

  useEffect(() => {
    if (transferCandidate.showModal) getJobsByClientIds();
  }, [transferCandidate.showModal]);

  const onFinish = async (values) => {
    transferJob(values.jobId, candidateActivity.id);
  };

  return (
    <Modal
      centered
      width={568}
      okText="Transfer"
      title="Transfer Candidate"
      className="s2-theme-style"
      wrapClassName="vertical-center-modal"
      open={transferCandidate.showModal}
      closeIcon={<i className="icon-closeable" />}
      okButtonProps={{
        loading: isTransferLoading,
      }}
      onOk={() => form.submit()}
      onCancel={transferCancelHandler}
      afterClose={afterModalClose}
      destroyOnClose
    >
      <Spin className="relative-spinner" spinning={isJobsLoading}>
        <Space direction="vertical">
          <Alert
            description="Transfers are only allowed to open jobs associated with this client. To continue, choose an eligible job from the dropdown."
            type="warning"
            showIcon
          />
          <Form form={form} onFinish={onFinish} layout="vertical">
            <Form.Item
              label="Select job for transfer"
              name="jobId"
              rules={[{ required: true, message: "Please select a job !" }]}
            >
              <Select
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={customJobHandleSearch}
                placeholder="Select a Job"
              >
                {jobList.map(({ id, title, client, jobLocation, extAtsId }) => (
                  <Option key={id} value={id}>
                    <JobSelectOption
                      title={title}
                      location={jobLocation.name}
                      client={client}
                      extAtsId={extAtsId}
                    >
                      {title}
                    </JobSelectOption>
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
        </Space>
      </Spin>
    </Modal>
  );
}
